import { SweetAlertIcon } from 'sweetalert2';

export const Message = {
    AuthenticationError: 'Error while authenticating, please retry!',
    ReviewWarning: 'Before publishing, we recommend that you examine the rating and the review you selected.',
    OnlySuperAdminsAllowed: 'Superadmins are not allowed to use offerx application.',
    UserExists: 'USEREXISTS',
    AccountPendingNoUpload: 'PENDINGNOUPLOAD',
    AccountPendingUpload: 'PENDINGWITHUPLOAD',
    AccountRejected: 'REJECTED',
    AccountReupload: 'REUPLOAD',
    WaitingForApproval: 'To access this feature, please complete your verification process.',
    RejectionMessage: `We regret to inform you that your account verification was not successful.`,
    DocumentNotPresent: 'Document not available.',
    FileNotPresent: 'File not present in repository.',
    CredentialMismatch: 'CREDENTIALMISMATCH',
    CustomAuthUnAvailable: 'CUSTOMAUTHUNAVAILABLE',
    JoinThroughLink: 'JOINTRULINK',
    UNSAVED_CHANGES_MESSAGE: 'You have unsaved changes. Do you really want to leave?',
    FOUND_UNSAVED_CHANGES: 'Found some unsaved changes, would you like to start where you left off?',
    CandidateNotFound: 'Candidate details not found in offerx application.',
    EmailMatchesWithCompanyDomain:
        'Kindly refrain from sending invites to the work email address. Instead, we kindly ask that you send them to personal email.',
    InvalidEmail: 'Please enter a valid email',
    ExcelRecordLimitExceed: 'Only 50 records are allowed.',
    ExcelPunchRecordLimitExceed: 'Only 100 records are allowed.',
    ExcelHeaderMismatch: 'Excel headers do not match with the provided template.',
    PasswordChanged: 'Password changed successfully. Click OK to Sign out.',
    PasswordCreated: 'Password created successfully. Click OK to Sign out.',
    PasswordReset: 'Password reset is successful.',
    EmailMigrationSuccess: 'Email migration is successful. Click OK to Sign out.',
    EmailAlreadyRegistered: 'Your email address is already registered with OfferX. Kindly click on Sign In.',
    EmailNotRegisteredWithOfferX: 'Your email address is not registered with OfferX. Register with OfferX to continue',
    ExistingAndNewEmail: 'Existing and new email cannot be same.',
    ProfileUpdated: 'Profile updated successfully',
    CompleteVerificationProcess: 'To access this feature, please complete your verification process.',
    HeadersWithNoData: 'Headers are present, but there is no data below them. Please upload a file with data.',
    EmptyExcelUploaded: 'Empty Excel file uploaded. Please upload a file with data.',
    UnableToReadExcel: 'Unable to read the uploaded file. Please make sure it is a valid Excel file.',
    NoFileSelected: 'No file selected. Please upload a valid Excel file.',
    ExcelProcessed: 'Excel processed successfully.',
    SomethingWentWrong: 'Something went wrong.',
    SomethingWentWrongTryAgain: 'Something went wrong. Please try again',
    DocumentSigned: 'Document signed succesfully.',
    DocmentUploaded: 'Document uploaded succesfully.',
    AttachmentSize5mb: 'Attachment size must be smaller than 5mb',
    RegisteredWithGoogle: 'You have been registered with Google or Microsoft.',
    InvalidCreds: 'You have entered invalid credentials.',
    JoinViaInvitation: 'Your joining satus has not yet been updated. Please join through the invitation link.',
    AccountBlocked: `Your account is blocked. Please contact your administrator.`,
    ExistingCandiateBulkInvitesMessage:
        'Kindly use the Bulk Invitations feature to extend invitations to your current employees for enrollment in the OfferX system. Upon their registration, you can access their records in the Onboarded tab to write Offboarding reviews. Additionally, make sure to invite your existing employees using their personal email IDs.',
    DownloadExcelSample: 'Download the attached sample and use it as a starting point for your own file.',
    EditAnEmployeeNote: 'Note: Any modification in assigned role(s) will be reflected only after employee re-login.',
    UnparliamentaryLanguageProhibited: 'Unparliamentary language and false accusations are prohibited.',
    ConfidentialInformationProhibited: 'Confidential information in reviews is prohibited.',
    ReviewCannotBeEdited: 'The review can be edited until one month post to the job start date',
    EditTimeLimit: 'If you wish to edit your review, you can do so within 4 hours from the time of submission.',
    UntruthfulReview: 'Your account will be suspended if OfferX found your review untruthful.',
    ConfirmReview: 'I confirm that the review is truthful and accurate to the best of my knowledge.',
    OnboardStatusPostAccepting: "What is the candidate's onboarding status post accepting the job offer?",
    EmployeeInvited: 'Employee invited successfully.',
    DomainAddedSuccessfully: 'Domain added successfully.',
    KYCAttempts: 'There are more than 2 instances of Adhaar mismatch. Please contact OfferX support team.',
    KYCAttemptsErrorMsg:
        'A candidate with the same values for date of birth, aadhaar last 4 digit and gender already exists in the system.',
    Invitation: 'Invitation sent successfully.',
    PunchedSuccessTitle: 'Offer punched successfully!',
    PunchedSuccess:
        'Now the candidates are being tracked in OfferX. \n We will notify you if another offer is issued to the same candidates.',
    PunchedFailed: 'Offers punched failed!',
    PunchedFailedMessage: 'Kindly retry the process again.',
    PunchedSuccessMessage: 'Now, the candidates are being tracked in OfferX.',
    DataPunchDownloadExcelSample:
        'Download the attached template and use it as a starting point for your own file. You can upload a maximum of 100 candidate details at a time.',
    RejectedMessage: 'Your account verification was not successful.',
    PrimaryEmail: 'Please login with your primary email ID',
    ContractRetract: 'Contract retracted successfully.',
    ContractDeclined: 'Contract declined successfully.',
    ContractReleased: 'Contract released successfully.',
    ContractRevised: 'Contract revised successfully.',
    ContractAccepted: 'Contract accepted successfully.',
};

export const SuccessIcon: SweetAlertIcon = 'success';
export const ErrorIcon: SweetAlertIcon = 'error';
export const InfoIcon: SweetAlertIcon = 'info';
export const WarningIcon: SweetAlertIcon = 'warning';
export const QuestionIcon: SweetAlertIcon = 'question';

export const SweetAlertTitle = {
    Profile: 'Profile',
    Empty: '',
    CompanyProfile: 'Company Profile',
    Warning: 'Warning',
    Sorry: 'Sorry',
    Status: 'Status',
    Error: 'Error',
    Success: 'Success',
    Alert: 'Alert',
};

export const ReviewMessages = [
    Message.UnparliamentaryLanguageProhibited,
    Message.ConfidentialInformationProhibited,
    Message.ReviewCannotBeEdited,
    Message.EditTimeLimit,
    Message.UntruthfulReview,
];
